
const websocket = {
  state: {
    socket: null
  },
  mutations: {
    updateWebsock (state) {  // commit该函数，建立websocket连接
      if (process.env.VUE_APP_MAIN_URL && WebSocket) {
        var baseUrl = process.env.VUE_APP_MAIN_URL.replace('http', 'ws') + '/websocket/' + localStorage.getItem('userId') + localStorage.getItem('companyId')
        state.socket = new WebSocket(baseUrl) // 建立连接
        // console.log(state.socket)
        state.socket.onclose = function () {
          // console.log('socket 已清空')
        }
        state.socket.onerror = function (err) {
          console.log(err)
        }
      } else {
        // 当前浏览器不支持websocket
      }
    }
  }
}

export default websocket
